import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

//Images
import h3 from "../img/h3.jpg";
import h4 from "../img/h4.jpg";
import h5 from "../img/h5.jpg";

///Animation
import { motion } from "framer-motion";
import { pageAnimation, photoAnim, fade } from "../animation";

const OurWork = () => {
  return (
    <Work variants={pageAnimation} exit="exit" initial="hidden" animate="show">
      <Movie>
        <motion.h2 variants={fade}>Data</motion.h2>
        <div className="line"></div>
        <Link to="/work/data">
          <motion.img variants={photoAnim} src={h3} alt="" />
        </Link>
      </Movie>

      <Movie>
        <motion.h2 variants={fade}>Research</motion.h2>
        <div className="line"></div>
        <Link to="/work/search">
          <motion.img variants={photoAnim} src={h4} alt="" />
        </Link>
      </Movie>

      <Movie>
        <motion.h2 variants={fade}>Robotics</motion.h2>
        <div className="line"></div>
        <Link to="/work/code">
          <motion.img variants={photoAnim} src={h5} alt="" />
        </Link>
      </Movie>
    </Work>
  );
};

const Work = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;
  background-color: white;
  h2 {
    padding: 1rem 0rem;
  }
  @media (max-width: 1000px) {
    padding: 0rem;
    h2 {
      text-align: center;
    }
  }
`;
const Movie = styled.div`
  padding-bottom: 10rem;
  .line {
    height: 0.5rem;
    background: #cccccc;
    margin-bottom: 3rem;
  }
  img {
    width: 100%;
    height: 70vh;
    object-fit: cover;
  }
  @media (max-width: 1000px) {
    .line {
      height: 0;
    }
  }
`;
export default OurWork;
